"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProfileBanner = void 0;
const identity_reducer_1 = require("@app/store/reducers/identity.reducer");
const icons_1 = require("@shared-modules/components/icons");
const object_1 = require("@utils/object");
const core_1 = require("@web3-react/core");
const unknown_png_1 = __importDefault(require("@assets/unknown.png"));
const React = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
require("./styles.scss");
const user_hooks_1 = require("@hooks/user.hooks");
const clipboard_hooks_1 = __importDefault(require("@shared-modules/utils/hooks/clipboard.hooks"));
const button_1 = require("@shared-modules/components/button");
const toast_1 = require("@shared-modules/components/toast");
const react_1 = require("react");
const translation_hooks_1 = require("@hooks/translation.hooks");
const ProfileBanner = (props) => {
    const { account = "" } = props;
    const { account: currentAccount } = (0, core_1.useWeb3React)();
    const [toastShareTrigger, setToastShareTrigger] = (0, react_1.useState)();
    const translator = (0, translation_hooks_1.useComponentTranslation)("profileBanner");
    const isMyProfile = account === currentAccount || !Boolean(account);
    const { data: profile } = (0, user_hooks_1.useUserByAccount)(account);
    const fullName = (0, object_1.concatStringsWithWhitespace)(profile === null || profile === void 0 ? void 0 : profile.firstName, profile === null || profile === void 0 ? void 0 : profile.lastName);
    const avatarURL = profile === null || profile === void 0 ? void 0 : profile.avatar;
    const { push } = (0, react_router_dom_1.useHistory)();
    const redirectToEdit = () => push("/profile/edit");
    const isIdentifiedUser = (0, identity_reducer_1.useInClaim)(identity_reducer_1.UserClaim.isIdentified);
    const avatarUrl = (isIdentifiedUser ? avatarURL || unknown_png_1.default : unknown_png_1.default);
    const [, copyText] = (0, clipboard_hooks_1.default)();
    const copyProfile = () => {
        setToastShareTrigger({});
        copyText(`${location.origin}/profile/${account}`);
    };
    return (React.createElement("header", { className: "c-profile-banner" },
        React.createElement("div", { className: "c-profile-banner__cover", style: {
                backgroundImage: `url(${"https://www.sliit.lk/wp-content/uploads/2018/02/minimalizm-gradient-background.jpg"})`,
            } },
            React.createElement("div", { className: "c-profile-banner__avatar", style: {
                    backgroundImage: `url(${avatarUrl})`,
                } }),
            React.createElement("div", { className: "c-profile-banner__links" },
                React.createElement(toast_1.Toast, { refresher: toastShareTrigger, text: translator("copiedLabel") },
                    React.createElement("a", { className: "c-profile-banner__link", onClick: copyProfile },
                        React.createElement("a", { className: "c-profile-banner__share" },
                            React.createElement(icons_1.ShareIcon, null),
                            React.createElement(icons_1.ShareIcon, { color: "red" })),
                        React.createElement("span", null, translator("share")))),
                (profile === null || profile === void 0 ? void 0 : profile.twitter) && (React.createElement("a", { className: "c-profile-banner__link", target: "_blank", rel: "noreferrer", href: profile === null || profile === void 0 ? void 0 : profile.twitter },
                    React.createElement("a", null,
                        React.createElement(icons_1.TwitterIcon, null),
                        React.createElement(icons_1.TwitterIcon, { color: "red" })),
                    React.createElement("span", null, "twitter"))),
                (profile === null || profile === void 0 ? void 0 : profile.instagram) && (React.createElement("a", { className: "c-profile-banner__link", target: "_blank", rel: "noreferrer", href: profile === null || profile === void 0 ? void 0 : profile.instagram },
                    React.createElement("a", null,
                        React.createElement(icons_1.InstagramIcon, null),
                        React.createElement(icons_1.InstagramIcon, { color: "red" })),
                    React.createElement("span", null, "instagram"))),
                (profile === null || profile === void 0 ? void 0 : profile.telegram) && (React.createElement("a", { className: "c-profile-banner__link", target: "_blank", rel: "noreferrer", href: profile === null || profile === void 0 ? void 0 : profile.telegram },
                    React.createElement("a", null,
                        React.createElement(icons_1.TelegramIcon, null),
                        React.createElement(icons_1.TelegramIcon, { color: "red" })),
                    React.createElement("span", null, "telegram"))))),
        React.createElement("div", { className: "c-profile-banner__profile" },
            React.createElement("div", { className: "c-profile-banner__profile-info" },
                React.createElement("div", { className: "c-profile-banner__name-container" },
                    React.createElement("div", { className: "c-profile-banner__name" },
                        fullName ? `${fullName}` : translator("unknownUser"),
                        " ",
                        React.createElement("span", null, (profile === null || profile === void 0 ? void 0 : profile.email) || "-")),
                    React.createElement("div", { className: "c-profile-banner__controls" }, isMyProfile && React.createElement(button_1.Button, { onClick: redirectToEdit }, translator("editButton")))),
                React.createElement("div", { className: "c-profile-banner__wallet" }, profile === null || profile === void 0 ? void 0 : profile.wallet),
                (profile === null || profile === void 0 ? void 0 : profile.description) && React.createElement("div", { className: "c-profile-banner__description" }, profile === null || profile === void 0 ? void 0 : profile.description)))));
};
exports.ProfileBanner = ProfileBanner;
